export default __webpack_public_path__ + "static/media/img10.8e2ed018.png";